export function debounce<T extends (...a: any[]) => any>(func: T, delay = 250): (...args: Parameters<T>) => void {
  let timer: null | number = null;

  return (...args) => {
    // @ts-ignore
    const context = (<any>this);

    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay) as unknown as number; // TODO: Fix nodejs types in tsconfig.
  };
}

/**
 * Trim a string from the right side with the given characters.
 * @param input The string to trim
 * @param characters The characters to trim
 */
export function rightTrim(input: string, characters: string) {
  let end = input.length - 1;
  while (characters.indexOf(input[end]) >= 0) {
    end -= 1;
  }
  return input.substr(0, end + 1);
}


export const getFileBuffer = (file: File) =>
new Promise<string | ArrayBuffer | null>((resolve, reject) => {
  const fileReader = new FileReader();
  fileReader.addEventListener("load", function() {
    resolve(this.result);
  });
  fileReader.addEventListener("error", () => {
    reject("Failed to Parse Selected File");
  });
  fileReader.readAsArrayBuffer(file);
});


